import React, { useEffect, useState } from 'react';
import { getDataReport } from '../../api/getData';
import { formatHide } from '../../utils/common';

import CustomTable from '../UI/CustomTable';
import FilterSearch from './FilterSearch';
import Summary from './Summary';

const Report = ({ summary }) => {
  const columns = [
    {
      title: 'STT',
      render: (index, record) => <>{index + 1}</>,
      key: 'stt',
    },
    {
      title: 'Họ và tên',
      dataIndex: 'name',
      key: 'full_name',
    },
    {
      title: 'Số điện thoại',
      dataIndex: 'phone',
      key: 'phone',
      render: (_, record) => <>{formatHide(record?.phone, 3)}</>,
    },
    {
      title: 'Số user giới thiệu',
      dataIndex: 'invite_count',
      key: 'f1',
    },
    {
      title: 'Hạng',
      dataIndex: 'rank',
      key: 'rank',
    },
    {
      title: 'Công ty thành viên',
      dataIndex: 'company',
      key: 'company',
    },
  ];

  const [dataSource, setDataSource] = useState();
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    search: '',
  });
  useEffect(() => {
    getDataReport(filter).then((res) => {
      setDataSource(res);
    });
  }, [filter, search]);
  const handleChangePage = (page) => {
    setFilter({
      ...filter,
      page: page,
    });
  };
  const onChange = (val) => {
    setSearch(val.target.value);
  };
  const onSubmit = () => {
    setFilter({
      ...filter,
      page: 1,
      search: search,
    });
  };
  return (
    <div>
      <Summary summary={summary} />
      <FilterSearch onChange={onChange} onSubmit={onSubmit} />
      <CustomTable
        columns={columns}
        pageSize={filter.limit}
        currentPage={filter.page}
        handlePagination={handleChangePage}
        data={dataSource?.data?.get_user_invite_list?.data}
        totalPage={Math.ceil(
          dataSource?.data?.get_user_invite_list?.total / filter.limit
        )}
      />
    </div>
  );
};

export default Report;
